import { theme, Avatar, AvatarSize, IconDictionary, Tab, TabGroup } from '@ketch-com/deck'
import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { TrackerListItemOrigin } from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'
import { Drawer } from 'components/ui-kit/drawer/Drawer'
import { avatarIconByOrigin } from 'pages/dataSentry/trackers/constants'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { Overview } from 'pages/dataSentry/trackers/trackerDetails/Overview'
import { Found } from 'pages/dataSentry/trackers/trackerDetails/Found'
import { Lineage } from 'pages/dataSentry/trackers/trackerDetails/Lineage'

export const TrackerDetails: React.FC = () => {
  const [tab, setTab] = useState(0)
  const { trackerOverview, setTrackerOverview, selectedProperty } = useDataSentryContext()

  return (
    <Drawer
      open={Boolean(trackerOverview)}
      onClose={() => setTrackerOverview?.(null)}
      PaperProps={{
        sx: {
          height: '90%',
          width: '100%',
          maxWidth: '1300px',
          margin: 'auto',
          padding: '32px',
          borderRadius: '37px 37px 0px 0px',
          overflow: 'hidden',
        },
      }}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h3" color={theme.palette.Text.Secondary}>
            Tracker
          </Typography>
          <Avatar
            borderColor={theme.palette.Black.o8}
            icon={avatarIconByOrigin[trackerOverview?.origin || TrackerListItemOrigin.TRACKER_ORIGIN_UNSPECIFIED]}
            textColor={theme.palette.Black.o48}
            size={AvatarSize['medium']}
          />
          <Typography variant="h3">{trackerOverview?.name}</Typography>
          <Typography variant="h3" color={theme.palette.Text.Secondary}>
            on
          </Typography>
          <Avatar
            borderColor={theme.palette.Black.o8}
            icon={IconDictionary.OGlobe}
            textColor={theme.palette.Black.o48}
            size={AvatarSize['medium']}
            variant="square"
            sx={{ borderRadius: 1.5 }}
          />
          <Typography variant="h3">{selectedProperty?.name || selectedProperty?.code}</Typography>
        </Box>
        <TabGroup value={tab} onChange={(event: React.SyntheticEvent, newValue: number) => setTab(newValue)}>
          <Tab size={'medium'} label="Overview" />
          <Tab size={'medium'} label="Where It Was Found" />
          {/* <Tab size={'medium'} label="Lineage" /> TODO: enable when completed */}
        </TabGroup>

        {tab === 0 ? <Overview /> : null}
        {tab === 1 ? <Found /> : null}
        {tab === 2 ? <Lineage /> : null}
      </Box>
    </Drawer>
  )
}
